$(function(){
  $('#menu-bar ul').slicknav();
});


// Set Times
 var currentTime = moment();
 var closingTime = moment().hour(13).minutes(0).seconds(0);
 var tomorrowClosingTime = moment().hour(13).minutes(0).seconds(0).add(1, 'day');

 // Set all times to Indianapolis Time Zone
 var currentTimeZone = currentTime.tz('America/Indiana/Indianapolis');
 var closingTimeZone = closingTime.tz('America/Indiana/Indianapolis');
 var tomorrowClosingTimeZone = tomorrowClosingTime.tz('America/Indiana/Indianapolis');

 // Set Conditional to show today/tomorrow countdown
 if ( currentTimeZone.isBefore(closingTimeZone) == true) {
 $('#clock').countdown(closingTime.toDate(), function(event) {
   $(this).html(event.strftime('%H hours, %M minutes Remaining for Same Day Prints'));
 });
 $('#clock-top-bar').countdown(closingTime.toDate(), function(event) {
   $(this).html(event.strftime('Order in next %H hours, %M minutes for Same Day Prints'));
 });
 } else {
 $('#clock').countdown(tomorrowClosingTimeZone.toDate(), function(event) {
   $(this).html(event.strftime('All orders will be fulfilled tomorrow - %H hours, %M minutes Remaining for Tomorrow'));
 });
 $('#clock-top-bar').countdown(tomorrowClosingTimeZone.toDate(), function(event) {
   $(this).html(event.strftime('All orders will be fulfilled tomorrow'));
 });
 }
 
